<template>
  <div>
    <b-navbar
      sticky
      toggleable="lg"
      type="dark"
      class="mb-5 pb-0 bg-primary"
    >
      <div class="container-xl">
        <b-navbar-brand
          left
          to="#"
          tag="h4"
          class="w-25"
        >
          <LogoPublic />
        </b-navbar-brand>
      </div>
    </b-navbar>
    <b-alert
      :show="saveerror==1"
      variant="danger"
    >
      <b>Your answers could not be saved, please contact {{ consultant_name }} for assistance</b>
    </b-alert>
    <div
      v-show="question_sequence>-1 && !showtext && !alldone && !incontrolled"
      class="text-container mx-auto mt-4"
    >
    <b-progress
        variant="info"
        height="1rem"
        :max="questions.length"
        align-v="center"
        class="gdq-progress-bar"
      >
        <b-progress-bar
          align-v="center"
          :value="question_sequence+1"
        />
      </b-progress>
      <div class="text-sm text-right mt-2">
        {{ question_sequence+1 }} {{ text_38 }} {{ questions.length }}
      </div>
    </div>
    <form onsubmit="return false;" class="text-container">
      <!-- Intro text section-->
      <div
        v-if="question_sequence > -1 && !incontrolled"
        class="mx-auto my-4 gdqquestion"
      >
        <h2 v-show="!alldone">
          <span v-show="questions[question_sequence].question_section == 'S'">{{ text_21 }}</span>
          <span v-show="questions[question_sequence].question_section == 'Q'">{{ text_22 }}</span>
          <span v-show="questions[question_sequence].question_section == 'E'">{{ text_24 }}</span>
        </h2>
        <span v-show="!alldone && questions[question_sequence].question_section == 'E'">{{ text_39 }}</span>
      </div>
      <!-- Start page -->
      <div
        v-show="question_sequence==-1"
        class="mx-auto mt-4"
      >
        <span
          v-if="isapi=='0'  && !this.survey_code_submitted"
          class="h2 page-title mb-3 d-block"
          v-html="text_8"
        />
        <p v-if="isapi=='0' && !this.survey_code_submitted">
          <span
            v-if="isapi=='0'"
            class=""
            v-html="text_9"
          />
        </p>
        <p
          v-if="isapi=='0' && !this.survey_code_submitted"
          class="mb-5"
        >
          {{ text_10 }}
        </p>
        <!--
        <b-form-group
          v-if="isapi=='0'"
          class="mb-4"
        >
          <b-form-input
            :class="`${anon ? 'g-anon' : '' }`"
            v-model="survey_code"
            :state="survey_code_valid"
            :placeholder="text_11"
            @keydown.space.prevent
          />
          <b-form-invalid-feedback id="survey_code-feedback">
            {{ text_7 }}
          </b-form-invalid-feedback>
        </b-form-group>-->

        <div v-show="!this.survey_code_submitted">
          <div class="code-input-wrapper mx-auto mb-3">
            <input
              v-for="(char, index) in characters"
              :key="index"
              v-model="characters[index]"
              @input="onInput($event, index)"
              @keydown="onKeyDown($event, index)"
              @paste="onPaste($event)"
              maxlength="1"
              pattern="[a-zA-Z0-9]*"
              :ref="'input-' + index"
              class="code-input text-uppercase"
              autocomplete="false"
            />
            <input class="d-none" type="hidden" v-model="survey_code" :state="survey_code_valid" />
          </div>
          <div v-if="!this.survey_code_valid" class="text-danger mb-3">
            {{ text_7 }}
          </div>
        </div>
        <div
          v-if="isapi=='0' && !!this.showconsent && !!this.survey_code_submitted"
          class="mt-5 mb-4"
        >
          {{ text_12 }}
        </div>
        <!-- Consent text -->
        <b-row class="">
          <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mx-auto">
            <p>
              <b-form-group v-show="this.groupsurveymember && this.groupsurveymember.groupsurveymember_formoption_id != '3' && !!this.survey_code_submitted" :state="consent_personal_valid">
                <b-form-checkbox
                  v-model="consent_personal"
                  value="1"
                >
                  <span
                    class=""
                    v-html="text_13"
                  />
                </b-form-checkbox>
                <b-form-invalid-feedback
                  id="consent_personal-feedback"
                  :state="consent_personal_valid"
                >
                  {{ text_6 }}
                </b-form-invalid-feedback>
              </b-form-group>
            </p>
            <!-- <p>
              <b-form-checkbox v-model="consent_research">
                <span
                  class="h5"
                  v-html="text_14"
                />
              </b-form-checkbox>
            </p> -->
          </div>
        </b-row>
      </div>
      <!--
        Question section
      -->
      <div
        v-if="showquestionsection  && !incontrolled"
        class="text-container gdqquestion"
      >
        <h3 class="my-4 py-4">
          <span
            v-show="questions[question_sequence].question_section=='Q'&&!questions[question_sequence].question_is_control"
          >{{ questions[question_sequence].question_number }}.
          </span>
          {{ questions[question_sequence].question_text }}
        </h3>
        <!-- Question type 1 - Vertical Radio Buttons -->
        <div
          v-show="questions[question_sequence].question_type==1"
          class="ml-0 pl-0"
        >
          <b-button-group
            vertical
            class="btn-group btn-group-vertical btn-group-toggle w-100 mb-5"
          >
            <label
              v-for="option in questions[question_sequence].options"
              :id="'o'+option.option_id"
              :key="option.option_id"
              class="btn btn-questionnaire my-2 text-left ml-0"
              :class="((answers[question_sequence] != null)&&(answers[question_sequence]===option.value))||currentoption===option.option_id&&!questions[question_sequence].question_is_control?'btn-primary':'btn-outline-primary'"
              :disabled="settinganswer"
              @click.prevent="currentoption=option.option_id;setanswer(question_sequence,option.value,questions[question_sequence].question_id);"
            >
              <span
                v-if="(answers[question_sequence] != null)&&(answers[question_sequence]===option.value)"
                class="mr-2"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z" />
                </svg>
              </span>
              <span
                v-if="(answers[question_sequence] != null)&&(answers[question_sequence]!==option.value)"
                class="w-10 mr-2"
              >
              &nbsp;&nbsp;&nbsp;
              </span>
              <input
                type="radio"
                autocomplete="off"
                class="text-left"
                :checked="(answers[question_sequence] != null)&&(answers[question_sequence]===option.value)"
              >{{ option.text }}
            </label>
          </b-button-group>
        </div>
        <!-- Question type 2 - Textbox -->
        <div
          v-show="questions[question_sequence].question_type==2"
          class="row mb-5"
        >
          <b-form-group class="col-12">
            <b-input-group>
              <b-form-input
                v-if="questions[question_sequence].only_digits==0"
                v-model="answers[question_sequence]"
                :maxlength="(questions[question_sequence].text_maxlength!=0)?questions[question_sequence].text_maxlength:300"
                class="col-12"
                :class="`${anon ? 'g-anon' : '' }`"
                @keyup.enter.native="answers[question_sequence]!=''?nextpage(300):false"
              />
              <b-form-input
                v-if="questions[question_sequence].only_digits==1"
                v-model="answers[question_sequence]"
                :maxlength="(questions[question_sequence].text_maxlength!=0)?questions[question_sequence].text_maxlength:20"
                class="col-12"
                :class="`${anon ? 'g-anon' : '' }`"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                @keyup.enter.native="answers[question_sequence]!=''?nextpage(300):false"
              />
            </b-input-group>
            <div v-if="questions[question_sequence].only_digits==1" class="mt-3 text-sm">
              {{ text_40 }}
            </div>

          </b-form-group>
          <div
            v-if="questions[question_sequence].only_digits==0"
            class="col-12 text-right mt-3"
          >

            {{ text_27 }}: {{ (questions[question_sequence].text_maxlength!=0)?questions[question_sequence].text_maxlength:300 - ((answers[question_sequence])?answers[question_sequence].length:0) }}
          </div>
        </div>
        <!-- Question type 3 - Textarea -->
        <div v-show="questions[question_sequence].question_type==3" class="mb-5">
          <b-form-textarea
            v-model="answers[question_sequence]"
            rows="7"
            :maxlength="(questions[question_sequence].text_maxlength!=0)?questions[question_sequence].text_maxlength:300"
            class="col-12"
            :class="`${anon ? 'g-anon' : '' }`"
          />
          <b-row>
            <div class="col-12 text-right mt-3">
              {{ text_27 }}: {{ (questions[question_sequence].text_maxlength!=0)?questions[question_sequence].text_maxlength:300 - ((answers[question_sequence])?answers[question_sequence].length:0) }}
            </div>
          </b-row>
        </div>
        <!-- Question type 4 - Horizontal radio buttons -->
        <div
          v-show="questions[question_sequence].question_type==4"
          class="row"
        >
          <b-button-group
            horizontal
            class="btn-group btn-group-horizontal btn-group-toggle col text-center"
          >
            <label
              v-for="option in questions[question_sequence].options"
              :id="'o'+option.option_id"
              :key="option.option_id"
              class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
              :class="(answers[question_sequence] != null)&&(answers[question_sequence]===option.value)||currentoption===option.option_id?'btn-primary':'btn-outline-primary'"
              :disabled="settinganswer"
              @click.prevent="currentoption=option.option_id;setanswer(question_sequence,option.value,questions[question_sequence].question_id);"
            >
              <span
                v-if="answers[question_sequence]&&answers[question_sequence]==option.value"
                class="mr-2"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z" />
                </svg>
              </span>
              <input
                type="radio"
                class="text-center"
              >{{ option.text }}
            </label>
          </b-button-group>
        </div>
        <div
          v-if="questions[question_sequence].question_section=='Q'&&questions[question_sequence].question_type==4"
          class="row mb-5"
        >
          <div
            class="col-6 text-primary mt-3"
          >
            {{ text_25 }}
          </div>
          <div
            class="col-6 text-right text-primary mt-3"
          >
            {{ text_26 }}
          </div>
        </div>
      </div>
      <div
        v-if="question_sequence > -1 && question_sequence < questions.length && showtext && !incontrolled"
        class="mx-auto gdqquestion mb-5"
      >
        <div v-show="questions[question_sequence].question_section=='Q'">
          <span
            class=""
            v-html="text_23"
          />
        </div>
      </div>
      <!-- FInal page -->
      <div
        v-show="alldone && saveerror==0"
        class="mx-auto"
      >
        <h2>
          {{ text_28 }}
        </h2>
        <div>
          {{ text_20 }}
        </div>
      </div>
      <!-- Navigation buttons -->
      <div
        v-show="!alldone &&!incontrolled"
        class="row mb-5"
      >
        <div class="col-6">
          <b-button
            v-show="question_sequence > 0"
            class="align-right"
            variant="secondary"
            @click.prevent="prevpage"
          >
            &lt; {{ text_1 }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            v-show="((question_sequence != -1) || answers[question_sequence] )"
            class="align-right"
            variant="primary"
            :disabled="((!(answers[question_sequence])||answers[question_sequence]=='') || settinganswer) && !showtext && questions[question_sequence].question_type!=3"
            @click.prevent="nextpage(300)"
          >
            {{ text_2 }}
          </b-button>
        </div>
        <div class="border-0 mx-auto col-12 pl-0 px-0">
          <span class="float-right col-12 col-sm-12 col-md-12 col-lg-6 col-xl-5">
            <b-button
              v-show="question_sequence==-1 && this.survey_code_submitted && this.groupsurveymember.groupsurveymember_formoption_id != 3"
              block
              class="btn"
              variant="primary"
              :disabled="consent_personal != 1 || (isapi == '0' && survey_code == '')"
              @click.prevent="surveymember_check"
            >
              {{ text_4 }}
            </b-button>
          </span>
        </div>
        <div class="border-0 mx-auto col-12 pl-0 px-0">
          <span class="float-right col-12 col-sm-12 col-md-12 col-lg-6 col-xl-5">
            <b-button
              v-show="question_sequence==-1 && !this.survey_code_submitted"
              block
              class="btn"
              variant="primary"
              :disabled="(isapi == '0' && survey_code == '')"
              @click.prevent="survey_code_check"
            >
              {{ text_2 }}
            </b-button>
          </span>
        </div>
      </div>
    </form>
    <div
      v-if="survey.survey_type_id != '3' && question_sequence==-1 && !this.survey_code_submitted"
      class="text-container mx-auto mt-4 text-sm"
    >
      {{ text_15 }}
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import LogoPublic from './LogoPublic.vue'

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export default {
  name: 'GDQQuestionnaire',
  components: {
    LogoPublic
  },
  props: {
    api: {
      type: String,
      required: false,
      default: '0'
    },
    successurl: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      firstgdqsequence: 9999,
      answering: false,
      saving: false,
      isapi: this.$props.api,
      saveerror: null,
      settinganswer: false,
      settingcontrolanswer: false,
      incontrolled: false,
      iPhone: this.$browserDetect.isIOS,
      userAgent: this.$browserDetect.meta.ua,
      survey_id: (this.$store.state.questionnaire_admin == true) ? this.$store.state.currentsurvey_id : null,
      survey_code: this.$store.state.questionnaire_admin_code,
      characters: this.$store.state.questionnaire_admin_code || Array(6).fill(''),
      token: this.$route.params.t ? this.$route.params.t : '',
      currentoption: 0,
      survey_code_valid: true,
      survey_code_submitted: false,
      f: false,
      alldone: false,
      consultant_id: 0,
      consultant_name: '',
      consultant_email: '',
      survey: {
        survey_type_id: 1,
        survey_language_id: 0,
        survey_end_date: null
      },
      groupsurveymember_id: 0,
      groupsurveymember: {
        groupsurveymember_survey_code: '',
        groupsurveymember_token: '',
        groupsurveymember_formoption_id: 1
      },
      question_sequence: -1,
      questions: [],
      answers: [],
      controlanswers: [],
      showtext: true,
      showconsent: true,
      consent_personal: false,
      consent_personal_valid: true,
      consent_research: false,
      consent_research_valid: true,
      text_1: '',
      text_2: '',
      text_3: '',
      text_4: '',
      text_5: '',
      text_6: '',
      text_7: '',
      text_8: '',
      text_9: '',
      text_10: '',
      text_11: '',
      text_12: '',
      text_13: '',
      text_14: '',
      text_15: '',
      text_16: '',
      text_17: '',
      text_18: '',
      text_19: '',
      text_20: '',
      text_21: '',
      text_22: '',
      text_23: '',
      text_24: '',
      text_25: '',
      text_26: '',
      text_27: '',
      text_28: '',
      text_29: '',
      text_30: '',
      text_31: '',
      text_32: '',
      text_33: '',
      text_34: '',
      text_35: '',
      text_36: '',
      text_37: '',
      text_38: '',
      text_39: ''
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    showquestionsection: function () {
      if (
        this.question_sequence > -1 &&
        this.question_sequence < this.questions.length &&
        !this.showtext &&
        !this.alldone
      ) {
        return true
      }
      return false
    }
  },
  created () {
    const data = {
      op: 'Questionnaire load',
      url: window.location.href,
      ll: 1
    }
    this.$store.dispatch('accesslog', data)
    this.surveymember_get()
      .then((resp) => {
        if (resp.data.total == 1) {
          this.survey_get()
            .then((resp) => {
              this.consultant_get()
                .then((resp) => {
                  this.answers = new Array()
                  this.questionnairetexts_get()
                  this.controlanswers = new Array()
                  this.gdqquestions_get()
                })
            })
        } else {
          alert('Incorrect link')
        }
      })
  },
  methods: {
    onInput (event, index) {
      this.survey_code_valid = true
      const value = event.target.value
      if (/^[a-zA-Z0-9]$/.test(value)) {
        this.characters[index] = value
        if (index < this.characters.length - 1) {
          this.$refs[`input-${index + 1}`][0].focus()
        }
        this.$emit('input', this.characters.join(''))
        this.survey_code = this.characters.join('')
      } else {
        this.characters[index] = ''
      }
    },
    onKeyDown (event, index) {
      this.survey_code_valid = true
      if (event.key === 'Backspace' && !this.characters[index] && index > 0) {
        this.$refs[`input-${index - 1}`][0].focus()
      }
    },
    onPaste (event) {
      this.survey_code_valid = true
      const paste = (event.clipboardData || window.clipboardData).getData('text')
      if (/^[a-zA-Z0-9]+$/.test(paste)) {
        const pasteCharacters = paste.slice(0, 6).split('')
        this.characters = pasteCharacters.concat(
          Array(6 - pasteCharacters.length).fill('')
        )
        this.$nextTick(() => {
          this.$refs[`input-${pasteCharacters.length - 1}`][0].focus()
        })
        this.$emit('input', this.characters.join(''))
        this.survey_code = this.characters.join('')
      }
    },
    surveymember_check () {
      this.survey_code = this.survey_code.replace(' ', '').toUpperCase() // Convert to uppercase
      this.survey_code = this.survey_code.trim()
      if (this.groupsurveymember.groupsurveymember_survey_code.toString() != this.survey_code.toString() && this.isapi == '0') {
        this.survey_code_valid = false
        return false
      }
      this.nextpage(300)
    },
    survey_code_check () {
      this.survey_code = this.survey_code.replace(' ', '').toUpperCase() // Convert to uppercase
      this.survey_code = this.survey_code.trim()
      if (this.groupsurveymember.groupsurveymember_survey_code.toString() != this.survey_code.toString() && this.isapi == '0') {
        this.survey_code_valid = false
        return false
      }
      this.survey_code_submitted = true
      if (this.groupsurveymember.groupsurveymember_formoption_id == 3) {
        console.log('3')
        this.showtext = false
        this.showconsent = false
        this.consent_personal = 1
        this.question_sequence = 0
      }
    },
    surveymember_get () {
      return new Promise((resolve) => {
        var filter = {
          'groupsurveymember_token': {
            operator: '=',
            value: this.token
          },
          'included_in_survey': {
            operator: '=',
            value: 1
          }
        }
        this.$store.dispatch('questionnaire_gdqsurveymember_fetch', { filter: filter })
          .then((resp) => {
            if (resp.data.total == 1) {
              this.groupsurveymember_id = resp.data.result[0].id,
              this.groupsurveymember.groupsurveymember_survey_code = resp.data.result[0].groupsurveymember_survey_code
              this.groupsurveymember.groupsurveymember_token = resp.data.result[0].groupsurveymember_token
              this.groupsurveymember.groupsurveymember_formoption_id = resp.data.result[0].groupsurveymember_formoption_id
              if (this.groupsurveymember.groupsurveymember_formoption_id == 3) {
                this.showconsent = false
                this.consent_personal = 1
              }
              this.survey_id = resp.data.result[0].survey_id
              if (resp.data.result[0].groupsurveymember_status_id < 4) {
                this.savefield(this.groupsurveymember_id, 'groupsurveymember_status_id', 3)
              }
            }
            resolve(resp)
          })
      })
    },
    survey_get () {
      return new Promise((resolve) => {
        this.$store.dispatch('questionnaire_gdqsurvey_fetch', { survey_id: this.survey_id })
          .then((resp) => {
            this.survey = resp.data
            // this.survey.survey_language_id = resp.data.survey_language_id;
            // this.survey.survey_end_date = resp.data.survey_end_date;
            // this.survey.survey_type_id = resp.data.survey_type_id;
            this.consultant_id = resp.data.user_id
            resolve(resp)
          })
      })
    },
    questionnairetexts_get () {
      this.$store.dispatch('questionnairetexts_fetch', { language_id: this.survey.survey_language_id })
        .then((resp) => {
          var maillink = '<a href="mailto:' + this.consultant_email + '">' + this.consultant_name + '</a>'
          this.text_1 = resp.data[1] ? resp.data[1] : 'Back'
          this.text_2 = resp.data[2] ? resp.data[2] : 'Next'
          this.text_3 = resp.data[3] ? resp.data[3] : 'Submit'
          this.text_4 = resp.data[4] ? resp.data[4] : 'Go to the GDQ survey'
          this.text_5 = resp.data[5] ? resp.data[5] : 'Some questions require a response - please answer any questions highlighted in red'
          this.text_6 = resp.data[6] ? resp.data[6] : ''
          this.text_7 = resp.data[7] ? resp.data[7] : 'Invalid code'
          this.text_8 = resp.data[8] ? resp.data[8] : 'Welcome'
          // Consultant name with mailto link
          this.text_9 = resp.data[9] ? resp.data[9].replace('[consultant_name]', maillink) : 'You have received an invitation to complete this questionnaire because XX XX considers it to be a valuable tool for finding out more about your work group in order to help you and your colleagues gain a deeper understanding of how you work together as a group, and what can be done to help your work group work better.'
          this.text_10 = resp.data[10] ? resp.data[10] : 'Please enter your personal code to launch the questionnaire.'
          this.text_11 = resp.data[11] ? resp.data[11] : 'Enter your code here.'
          this.text_12 = resp.data[12] ? resp.data[12] : '...And please confirm that we have your consent to store your responses and personal details:'
          // Privacy policy
          var link = (this.survey.survey_language_id == 154 ? '<a href="https://gdq.se/sv/integritetspolicy2/" target="_new">' : '<a href="https://gdq.se/en/privacypolicy/" target="_new">')
          this.text_13 = resp.data[13] ? resp.data[13] : 'Yes, I give my consent to GDQ Associates to process my personal data for the reasons set out above in accordance with the company\'s privacy policy. If you would like further information about how we process your personal data and your rights in this regard, click here.'
          this.text_13 = this.text_13.replace('[link]', link)
          this.text_13 = this.text_13.replace('[/link]', '</a>')
          // Consent research
          this.text_14 = resp.data[14] ? resp.data[14] : 'I give my consent to my responses to this questionnaire being used anonymously without any identifying markers for the purposes of test development, standardisation and research.'
          let textno = 15
          if (this.survey.survey_type_id == 2) {
            textno = 36
          }
          this.text_15 = resp.data[textno] ? resp.data[textno] : 'All rights related to this questionnaire and the associated testing procedure and consultancy processes are the property of GDQ Associates AB. The Group Development Questionnaire (GDQ) is protected by copyright laws. Duplicating, printing or otherwise copying the contents of this questionnaire, in whole or in part, is thus prohibited without the permission of the copyright holder. It is prohibited for anyone other than a certified GDQ consultant to use this questionnaire.'
          this.text_16 = resp.data[16] ? resp.data[16] : 'Questionnaire already submitted'
          // Already completed
          this.text_17 = resp.data[17] ? resp.data[17].replace('[consultant_name]', maillink) : ''
          this.text_18 = resp.data[18] ? resp.data[18] : 'Please answer all questions marked with red color'
          this.text_19 = resp.data[19] ? resp.data[19].replace('[survey_end_date]', this.survey.survey_end_date) : ''
          this.text_20 = resp.data[20] ? resp.data[20] : 'Thank you!'
          this.text_21 = resp.data[21] ? resp.data[21] : 'Group Information and Personal Information'
          this.text_22 = resp.data[22] ? resp.data[22] : 'GDQ Questions'
          this.text_23 = resp.data[23] ? resp.data[23] : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_24 = resp.data[24] ? resp.data[24] : 'Free text response'
          this.text_25 = resp.data[25] ? resp.data[25] : 'Never true'
          this.text_26 = resp.data[26] ? resp.data[26] : 'Always true'
          this.text_27 = resp.data[27] ? resp.data[27] : 'Number of characters remaining '
          this.text_28 = resp.data[28] ? resp.data[28] : 'Thank you!'
          this.text_29 = resp.data[29] ? resp.data[29].replace('[consultant_name]', maillink) : 'Du har fått en inbjudan till denna enkät  [consultant_name] ser den som ett värdefullt verktyg för att ta reda på din och din grupps upplevelse av organisatoriska frågor. Syftet är att hjälpa dig och dina kollegor få insikt i hur ni upplever det organisatoriska stödet och uppmärksamma inom vilka områden fokus för utveckling bör riktas.'
          this.text_30 = resp.data[30] ? resp.data[30] : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_31 = resp.data[31] ? resp.data[31] : 'OSC Questions'
          if (this.survey.survey_type_id == 3) {
            this.text_23 = this.text_30
            this.text_9 = this.text_29
            this.text_22 = this.text_31
          }
          this.text_37 = resp.data[37] ? resp.data[37] : '* = mandatory question'
          this.text_38 = resp.data[38] ? resp.data[38] : 'of'
          this.text_39 = resp.data[39] ? resp.data[39] : 'Your free text responses will be included in the GDQ report alongside other people\'s free text responses.'
          this.text_40 = resp.data[40] ? resp.data[40] : 'Enter with numbers'
        })
    },
    async setanswer (id, answer, question_id) {
      if (this.settinganswer) { return false }
      this.settinganswer = true
      if (this.questions[this.question_sequence].question_is_control == 1) {
        this.controlanswers[question_id] = answer
        // Nullify all answers to questions that are controlled by this question
        for (var i = 0; i < this.questions.length; i++) {
          if (this.questions[i].controlquestion_id == question_id) {
            this.answers[i] = null
          }
        }
      } else {
        this.answers[id] = answer
      }
      await this.nextpage(300)
        .then(() => {
          this.settinganswer = false
        })
    },
    nextpage: async function (millisecs) {
      await sleep(millisecs).then(() => {
        var _this = this
        // this.saveanswers(this.groupsurveymember_id,this.questions,this.answers)
        if (this.question_sequence == this.questions.length - 1) {
          let logdata = {
            op: 'Questionnaire done',
            url: window.location.href,
            ll: 1
          }
          this.$store.dispatch('accesslog', logdata)
          if (this.successurl != '') {
            axios.get(this.successurl, { crossDOmain: true })
          }
          this.saveanswers(this.groupsurveymember_id, this.questions, this.answers)
            .then((resp) => {
              if (!resp.data.result || resp.data.result != 'OK') {
                this.saveerror = 1
                this.senderror(JSON.stringify(resp.data))
                this.saving = false
              } else {
                this.saveerror = 0
                this.savefield(this.groupsurveymember_id, 'groupsurveymember_status_id', 4)
                this.$store.dispatch('addingsurveymember_set', { addingsurveymember: false })
                if (this.successurl != '') {
                  axios.get(this.successurl, { crossDomain: true })
                }
                if (this.survey.addon_survey != 0) {
                  this.$router.push('/addonsurvey/' + this.survey.addon_survey + '/' + this.groupsurveymember_id)
                }
                this.saving = false
                this.alldone = true
              }
            })
          return false
        }
        let pp = parseInt(this.question_sequence)
        pp = pp + 2
        let logdata = {
          op: 'Questionnaire page: ' + pp,
          url: window.location.href,
          ll: 5
        }
        this.$store.dispatch('accesslog', logdata)
        if (_this.showtext) {
          _this.showtext = false
          if (_this.question_sequence > -1) {
            return
          }
        }
        var oldq = _this.question_sequence != -1 ? this.questions[this.question_sequence] : { question_section: 'S' }
        var newq = _this.question_sequence < this.questions.length ? this.questions[this.question_sequence + 1] : null
        if (newq != null) {
          if ((newq.question_section != oldq.question_section) && newq.question_section != 'E') {
            _this.showtext = true
          }
        }
        _this.question_sequence++

        if (_this.questions[_this.question_sequence].controlquestion_id != 0) {
          if (
            // We have an answer for the control question
            (_this.controlanswers[_this.questions[_this.question_sequence].controlquestion_id] &&
            // And the answer is not the one we want
            _this.controlanswers[_this.questions[_this.question_sequence].controlquestion_id] !=
            _this.questions[_this.question_sequence].show_on_value) ||
            !_this.controlanswers[_this.questions[_this.question_sequence].controlquestion_id]
          ) {
            _this.incontrolled = true
            _this.nextpage(0)
          } else {
            _this.incontrolled = false
          }
        } else {
          _this.incontrolled = false
        }
      })
    },
    prevpage: function () {
      if (this.question_sequence === this.firstgdqsequence && !this.showtext) {
        this.showtext = true
        return true
      }
      if (this.showtext) { this.showtext = false }
      this.question_sequence--
      if (this.questions[this.question_sequence] &&
        this.questions[this.question_sequence].controlquestion_id != 0
      ) {
        if (
          !this.controlanswers[this.questions[this.question_sequence].controlquestion_id] ||
          this.controlanswers[this.questions[this.question_sequence].controlquestion_id] !=
          this.questions[this.question_sequence].show_on_value
        ) {
          this.prevpage()
        }
      }
    },
    consultant_get () {
      return new Promise((resolve) => {
        this.$store.dispatch('questionnaire_gdqconsultant_fetch', { user_id: this.consultant_id })
          .then((resp) => {
            this.consultant_email = resp.data.email
            this.consultant_name = resp.data.first_name + ' ' + resp.data.family_name
            resolve(resp)
          })
      })
    },
    // --------------------------------------------------------
    // Get all questions and answers for this here participant
    // --------------------------------------------------------
    gdqquestions_get: function () {
      var action = 'questionnaire_gdqallquestions_fetch'
      // Get ALL questions (GDQ and General)
      return new Promise((resolve) => {
        this.$store.dispatch(action, { survey_id: this.survey_id, language_id: this.survey.survey_language_id })
          .then((resp) => {
            let questions = resp.data
            this.questions = questions
            for (let i = 0; i < this.questions.length; i++) {
              const question = this.questions[i]
              if (question.question_section === 'Q' && question.sequence < this.firstgdqsequence) {
                this.firstgdqsequence = question.sequence
              }
            }
            resolve(resp)
          })
      })
    },
    saveanswers: function (groupsurveymember_id, questions, answers) {
      this.saving = true
      var saveanswers = []
      var question_sequence = 0
      questions.forEach(function (item, index) {
        if (!item.question_is_control || item.question_is_control == 0) {
          var newanswer = {
            question_id: item.question_id,
            question_section: item.question_section == 'Q' ? 'Q' : 'G',
            question_number: item.question_number,
            answer: answers[question_sequence]
          }
          saveanswers.push(newanswer)
        }
        question_sequence++
      })
      var data = {
        groupsurveymember_id: groupsurveymember_id,
        answers: saveanswers
      }
      return this.$store.dispatch('questionnaire_gdqallanswers_save', data)
        .then((resp) => {
          return resp
        })
    },
    savefield (id, fieldname, value) {
      if (!this.loading) {
        if (fieldname == 'survey_reminder') {
          if (!value) { value = 0 }
        }
        if (fieldname.indexOf('_date') != -1) {
          value = this.format_date(value)
        }
        if (fieldname.indexOf('_time') != -1) {
          if (value != null && value != '') { value = this.format_time(value) } else { value = '00:00' }
        }
        var data = {
          id: id,
          [fieldname]: value
        }
        this.formchanged = false
        this.$store.dispatch('questionnaire_surveymember_setstatus', { surveymember: data })
          .then((resp) => {
            return (resp)
          })
      }
    },
    // Send e-mail on save error
    senderror (text) {
      var send_mail_subject = 'GDQ: Error saving'
      var send_mail_text = text
      var payload = {
        mail_to: 'qbjorn@gmail.com',
        mail_subject: send_mail_subject,
        mail_text: send_mail_text
      }
      return this.$store.dispatch('mail_send', payload)
    },
    //= ================
    // HELPER FUNCTIONS
    //= ================
    format_date (date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (isNaN(year)) { return '' }
      if (Number.isNaN(month)) { return '' }
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    format_time (date) {
      if (date.length == 5) {
        return date
      }
      var d = new Date(date)
      var h = d.getHours()
      var m = d.getMinutes()
      var hour = (h > 9 ? '' : '0') + h
      var minute = (m > 9 ? '' : '0') + m
      var thistime = hour + ':' + minute
      return thistime
    }
  },
  watch: {
    length (newLength) {
      this.characters = Array(newLength).fill('')
    }
  }
}
</script>
<style>
/*
.btn {
  border-radius: 0px !important;
}
*/
.btn-questionnaire {
  border-radius: 0px !important;
  font-size: 24px !important;
  font-weight: 400 !important;
}
.btn-outline-primary:hover {
  background-color: white !important;
  border-color: #007d8f !important;
  color: #007d8f !important;
  border-radius: 0px !important;
}
.btn-questionnaire-horizontal {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
[type='radio'] {
  display: none;
}
.gdqquestion {
  transition: opacity 2.5s;
}
.gdqquestion-enter-active, .gdqquestion-leave-active {
  transition: opacity 2.5s;
}
.gdqquestion-enter, .gdqquestion-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.text-container {
  max-width: 794px;
  margin: 0 auto;
}
</style>
